import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { withTranslation } from 'react-i18next';
import { isEqual, cloneDeep } from 'lodash';
import { Button } from '../../../../UI/Common';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const _startIndex = result.length - 1 - startIndex;
  const _endIndex = result.length - 1 - endIndex;
  const [removed] = result.splice(_startIndex, 1);
  result.splice(_endIndex, 0, removed);
  return result;
};

const getItemStyle = (isDragging, draggableStyle, isLast) => ({
  display: 'flex',
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  //   paddingLeft: grid * 4,
  //   margin: `0 0 ${grid}px 0`,
  // change background colour if dragging
  // background: 'transparent',
  // marginBottom: isLast ? 0 : 5,
  // styles we need to apply on draggables
  ...draggableStyle,
});

const getDragIconStyle = (isDragging) => ({
  userSelect: 'none',
  background: isDragging ? 'lightgreen' : '#EFEFEF',
  color: 'black',
  fontWeight: 600,
});

function MapComponentLibrary({ onAddShape, onUploadBg, shapeArr, ...props }) {
  const { t } = props;
  const [shapes, updateShapes] = React.useState([]);
  React.useEffect(() => {
    updateShapes(cloneDeep(shapeArr).reverse());
  }, [shapeArr]);
  function getSelectedBg(shape) {
    if (props.selectedShape) {
      if (props.selectedShape.id === shape.id) {
        return 'bg-goldenrod color-white';
      } else return '';
    } else return '';
  }
  function onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const _shapes = reorder(
      shapeArr,
      result.source.index,
      result.destination.index,
    );
    props.onReorderShapes(_shapes);
  }
  return (
    <div className="map-component-library">
      <div className="d-flex flex-column mb-1">
        <Button classes="mb-1" onClick={() => onAddShape(1)}>
          {t('Sensor')}
        </Button>
        <Button classes="mb-1" onClick={() => onAddShape(2)}>
          {t('Group')}
        </Button>
        <Button classes="mb-1" onClick={() => onAddShape(3)}>
          {t('Sensor (Simple)')}
        </Button>
        <Button classes="mb-1" onClick={() => onAddShape(4)}>
          {t('Trend Chart')}
        </Button>
        <div className="position-relative">
          <Button
            classes="p-0 d-flex w-100 justify-content-center align-items-center"
            style={{ lineHeight: 1 }}
          >
            {t('Background')}
          </Button>
          <input
            type="file"
            accept="image/*"
            onChange={onUploadBg}
            className="position-absolute w-100 h-100"
            style={{ top: 0, opacity: 0 }}
          />
        </div>
      </div>
      <div className="d-flex flex-column flex-1">
        <div className="text-center" style={{ borderTopStyle: 'double' }}>
          {t('Shapes')}
        </div>
        <div className="d-flex flex-column-reverse" style={{ flex: 1 }}>
          {shapes && shapes.length ? (
            <div className="d-flex flex-column">
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="shapesList">
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="d-flex flex-column"
                      // style={getListStyle(snapshot.isDraggingOver, props.color)}
                    >
                      {shapes.map((shape, index) => (
                        <Draggable
                          key={shape.id}
                          draggableId={shape.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                                index === shapes.length - 1,
                              )}
                            >
                              <div className="d-flex w-100 mt-1">
                                <Button
                                  color="transparent"
                                  classes={`p-0 d-flex justify-content-center align-items-center`}
                                  style={{ width: '15%' }}
                                  onClick={() => props.onRemoveShape(shape)}
                                >
                                  <i className="md-icon mr-0">delete_outline</i>
                                </Button>
                                <Button
                                  color="transparent"
                                  classes={`${getSelectedBg(
                                    shape,
                                  )} d-flex justify-content-center align-items-center`}
                                  style={{
                                    flex: 1,
                                    padding: '0px 5px',
                                  }}
                                  onClick={() => props.onSelectShape(shape)}
                                >
                                  <span
                                    style={{
                                      lineHeight: 1,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {shape.name}
                                  </span>
                                </Button>
                                <div
                                  color="transparent"
                                  className={`p-0 d-flex justify-content-center align-items-center`}
                                  style={{
                                    width: '15%',
                                    ...getDragIconStyle(snapshot.isDragging),
                                  }}
                                >
                                  <i className="md-icon mr-0">drag_handle</i>
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default withTranslation('app')(MapComponentLibrary);
